import { render, staticRenderFns } from "./MovementOrderItemCard.vue?vue&type=template&id=5627d2d7&scoped=true&"
import script from "./MovementOrderItemCard.vue?vue&type=script&lang=js&"
export * from "./MovementOrderItemCard.vue?vue&type=script&lang=js&"
import style0 from "./MovementOrderItemCard.vue?vue&type=style&index=0&id=5627d2d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627d2d7",
  null
  
)

export default component.exports